import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import { useConfig } from '../context/ConfigContext';

const Speakers = () => {
    const [speakers, setSpeakers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedSpeaker, setSelectedSpeaker] = useState(null);
    const { config } = useConfig();

    useEffect(() => {
        const fetchSpeakers = async () => {
            try {
                const response = await api.get('/speakers?status=active');
                setSpeakers(response.data);
            } catch (error) {
                console.error("Error fetching speakers", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchSpeakers();
    }, []);

    const pageDesign = config?.pageDesigns?.speakers || {};
    const primaryColor = config?.primaryColor || '#00595b';
    const secondaryColor = config?.secondaryColor || '#ff5874';
    const cardBorderColor = pageDesign.cardBorderColor || secondaryColor;
    const nameColor = pageDesign.nameColor || secondaryColor;
    const titleColor = pageDesign.titleColor || secondaryColor;
    const pageTitle = pageDesign.title || 'Conferencistas';

    return (
        <div className="animate-fadeIn pb-20 font-sans max-w-4xl mx-auto px-4">
            <header className="mb-8 text-center">
                <h1
                    className="text-3xl sm:text-4xl font-black capitalize tracking-wider"
                    style={{ color: titleColor }}
                >
                    {pageTitle}
                </h1>
            </header>

            {isLoading ? (
                <div className="flex justify-center py-20">
                    <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12 max-w-2xl mx-auto">
                    {speakers.map((s) => (
                        <div
                            key={s.id}
                            className="flex flex-col items-center text-center group cursor-pointer"
                            onClick={() => setSelectedSpeaker(s)}
                        >
                            <div className="relative mb-3">
                                <div
                                    style={{ borderColor: 'transparent' }}
                                    className="w-36 h-36 sm:w-44 sm:h-44 rounded-full border-0 overflow-hidden relative z-10 shadow-xl transition-transform duration-300 group-hover:scale-105 bg-transparent"
                                >
                                    <img
                                        src={s.photo_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(s.name)}&background=00595b&color=ffffff`}
                                        alt={s.name}
                                        className="w-full h-full object-cover object-top"
                                    />
                                </div>
                            </div>

                            <h3
                                style={{ color: nameColor }}
                                className="text-[18px] sm:text-[20px] font-black leading-tight mt-1 transition-transform duration-300 group-hover:-translate-y-0.5"
                            >
                                {s.name}
                            </h3>
                            <p className="text-xs font-medium mt-1 uppercase tracking-wider text-white/90 px-4">
                                {s.profession}
                            </p>
                        </div>
                    ))}
                    {speakers.length === 0 && (
                        <div className="col-span-full text-center py-16 bg-white/5 rounded-3xl border-2 border-dashed border-white/20 text-white/60 font-bold uppercase tracking-widest text-xs">
                            Próximamente
                        </div>
                    )}
                </div>
            )}

            {/* Speaker Detail Modal matching PDF Page 4 Screen 1 */}
            {selectedSpeaker && (
                <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4 animate-fadeIn">
                    <div
                        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
                        onClick={() => setSelectedSpeaker(null)}
                    ></div>

                    <div className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl border-0 border-transparent shadow-2xl animate-scaleUp bg-white">
                        <button
                            className="absolute top-4 right-6 text-slate-400 hover:text-black text-2xl font-bold z-10"
                            onClick={() => setSelectedSpeaker(null)}
                        >
                            ✕
                        </button>

                        <div className="p-8 sm:p-10 flex flex-col items-center text-center">
                            <div
                                style={{ borderColor: 'transparent' }}
                                className="w-36 h-36 sm:w-44 sm:h-44 rounded-full border-0 overflow-hidden mb-6 shadow-lg bg-transparent"
                            >
                                <img
                                    src={selectedSpeaker.photo_url || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedSpeaker.name)}&background=00595b&color=ffffff`}
                                    alt={selectedSpeaker.name}
                                    className="w-full h-full object-cover object-top"
                                />
                            </div>

                            <h2
                                style={{ color: nameColor }}
                                className="text-2xl sm:text-3xl font-black mb-2"
                            >
                                {selectedSpeaker.name}
                            </h2>

                            <p
                                style={{ color: primaryColor }}
                                className="text-xs sm:text-sm font-bold uppercase tracking-wider mb-6"
                            >
                                {selectedSpeaker.profession}
                            </p>

                            <div className="w-full border-t border-slate-100 my-2"></div>

                            <div className="text-slate-700 leading-relaxed text-xs sm:text-sm text-left max-w-md whitespace-pre-line pt-2">
                                {selectedSpeaker.profile || "Sin información adicional."}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Speakers;
